import Vue from 'vue'
import Vuex from 'vuex'

const requireAll = ctx =>
  ctx
    .keys()
    .map(c => ({
      name: c.replace(/^\.\/([a-zA-Z_]+)\.store\.js$/, '$1'),
      value: ctx(c)
    }))
    .reduce((acc, { name, value }) => {
      if (name === 'global') {
        // 默认 global.store 不使用命名空间
        // global.store 直接作用于根作用域
        acc[name] = value.default
      } else {
        acc[name] = {
          namespaced: true,
          // eslint-disable-next-line new-cap
          ...value.default
        }
      }
      return acc
    }, {})

Vue.use(Vuex)

export default new Vuex.Store({
  modules: requireAll(require.context('./modules', false, /\.store\.js$/))
})
